import { format } from 'date-fns'
import { de, enUS, es, fr, it, uk } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

import { intervalShortcuts } from '../components/DatePickerComponent/DatePickerConfig'
import { DateShortcutKey, DateShortcut } from '../components/DatePickerComponent/types'

export function useStartEndDateText(
  startDate?: Date | null,
  endDate?: Date | null,
  dateShortcutKey?: DateShortcutKey | null,
  shortcuts: Record<DateShortcutKey, DateShortcut> = intervalShortcuts,
) {
  const { t, i18n } = useTranslation()
  const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]
  const dateLocale = { en: enUS, uk, es, fr, it, de }[language] || enUS

  if (dateShortcutKey) {
    const shortcut =
      shortcuts[dateShortcutKey] ??
      (intervalShortcuts as Record<string, DateShortcut>)[dateShortcutKey]

    if (shortcut) {
      return t(shortcut.title, shortcut.title)
    }
  }

  if (startDate && endDate) {
    const startDateFormat = format(startDate, 'd MMM', { locale: dateLocale })
    const endDateFormat = format(endDate, 'd MMM yyyy', { locale: dateLocale })

    return `${startDateFormat} - ${endDateFormat}`
  } else if (startDate) {
    return format(startDate, 'd MMM', { locale: dateLocale })
  } else {
    return t('datePicker.shortcuts.allTime', 'All time')
  }
}
